import { FC } from 'react';
import { KeywordSuggest } from 'components/KeywordSuggest';
import { KeywordHooksType } from 'components/SearchConditionSettingForm/types';
import { JobCountQuery } from '@doda/common/src/services/getJobCountAPI';
import styles from './index.module.scss';

/**
 * 検索条件設定コンポーネント キーワード の Props
 */
interface Props {
  /** 包括されたキーワード関連のフックタイプ */
  includeKeyword: KeywordHooksType;
  /** 除外されたキーワード関連のフックタイプ */
  excludeKeyword: KeywordHooksType;
  /** 求人数を更新するための関数 */
  updateJobCount: (currentCondition?: JobCountQuery) => Promise<void>;
}

/**
 * 検索条件設定コンポーネント キーワード
 *
 * @param {Props} props - キーワードの検索条件設定に必要なプロパティ
 * @returns {JSX.Element} Reactコンポーネント
 */
export const KeywordContents: FC<Props> = ({
  includeKeyword,
  excludeKeyword,
  updateJobCount,
}) => {
  return (
    <div className={styles.searchConditionSettingForm__keywordContents}>
      <div
        className={styles.searchConditionSettingForm__keywordContents__wrapper}
      >
        <KeywordSuggest
          state={{
            isInclude: true,
            ...includeKeyword.state,
          }}
          functions={includeKeyword.updateFunctions}
          updateJobCount={updateJobCount}
        />
      </div>
      <div
        className={styles.searchConditionSettingForm__keywordContents__wrapper}
      >
        <KeywordSuggest
          state={{
            isInclude: false,
            ...excludeKeyword.state,
          }}
          functions={excludeKeyword.updateFunctions}
          updateJobCount={updateJobCount}
        />
      </div>
    </div>
  );
};
